const css = `.yC4wxG__container{z-index:10009;position:fixed;inset:0;overflow:hidden auto}.yC4wxG__container.yC4wxG__hidden{overflow-y:hidden}.yC4wxG__overlay{background-color:#48699726;position:fixed;inset:0}.yC4wxG__overlay.yC4wxG__transparent{background-color:#0000}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"container":"yC4wxG__container","hidden":"yC4wxG__hidden","overlay":"yC4wxG__overlay","transparent":"yC4wxG__transparent"};
